module.exports = __webpack_public_path__ + "static/media/news_banner.7e470fef.png";